import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    const blockHalfTextTeamSliders = document.querySelectorAll('.block-half-text-team__slider');
    const blockHalfTextTeamStackedMedia = window.matchMedia('(max-width: 1280px)');

    if (blockHalfTextTeamSliders.length === 0) return;

    blockHalfTextTeamSliders.forEach(function (blockHalfTextTeamSlider) {
        const blockHalfTextTeamSlides = blockHalfTextTeamSlider.querySelectorAll('.swiper-slide');
        let blockHalfTextTeamSwiper = null;

        const setupBlockHalfTextTeamSlider = function () {
            if (!blockHalfTextTeamStackedMedia.matches) {
                if (blockHalfTextTeamSwiper) {
                    blockHalfTextTeamSwiper.destroy(true, true);
                    blockHalfTextTeamSwiper = null;
                }

                return;
            }

            if (blockHalfTextTeamSwiper || blockHalfTextTeamSlides.length <= 1) return;

            blockHalfTextTeamSwiper = new Swiper(blockHalfTextTeamSlider, {
                modules: [Navigation],
                slidesPerView: 1,
                spaceBetween: 24,
                speed: 500,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                },
                navigation: {
                    prevEl: blockHalfTextTeamSlider.querySelector('.block-half-text-team__control--prev'),
                    nextEl: blockHalfTextTeamSlider.querySelector('.block-half-text-team__control--next'),
                },
                observer: true,
                observeParents: true,
            });
        };

        setupBlockHalfTextTeamSlider();

        window.addEventListener('resize', setupBlockHalfTextTeamSlider, { passive: true });
        blockHalfTextTeamStackedMedia.addEventListener('change', setupBlockHalfTextTeamSlider);
    });

    document.addEventListener('productTabPanelShown', function (event) {
        window.requestAnimationFrame(function () {
            event.target.querySelectorAll('.block-half-text-team__slider').forEach(function (blockHalfTextTeamSlider) {
                if (blockHalfTextTeamSlider.swiper) {
                    blockHalfTextTeamSlider.swiper.update();
                }
            });
        });
    });
});
